// extracted by mini-css-extract-plugin
module.exports = {"figure":"Figure4--figure--1HCxz","background":"Figure4--background--2hjJ8"};